import { Divider, Typography } from '@material-ui/core'
import React, { PropsWithChildren } from 'react'
import { Trans } from 'react-i18next'
import AuthenticateContent from '../../layouts/components/authenticateContent'
import { useStyles } from './styles.css'
import { BusinessHours, SpecialClosing } from '@sugg-gestion/ubidreams-react-suggpro'
import BookingCalendar from './bookingCalendar'

interface Props {
    fullDays: Array<string>
    onFullDayUpdate: (days: Array<string>) => void
    bookingInProgress: boolean
    businessHours: BusinessHours | null
    specialClosing: SpecialClosing[]
}

const BookingView: React.FC<PropsWithChildren<Props>> = ({
    fullDays,
    onFullDayUpdate,
    bookingInProgress,
    children,
    businessHours,
    specialClosing,
}) => {
    const classes = useStyles()

    return (
        <AuthenticateContent withAction={false}>
            <Typography variant="h1" className={classes.title}>
                <Trans i18nKey="views.booking.fullDay.title" />
            </Typography>
            <BookingCalendar
                businessHours={businessHours}
                fullDays={fullDays}
                specialClosing={specialClosing}
                onChangeFullDays={onFullDayUpdate}
                bookingInProgress={bookingInProgress}
            />
            <Divider variant="middle" className={classes.divider} />
            <div className={classes.root}>{children}</div>
        </AuthenticateContent>
    )
}

export default BookingView
